module.exports = {
  backToMain: 'กลับไปหน้าหลัก',
  print: 'พิมพ์',
  savePDF: 'บันทึกเป็น PDF',
  saveWord: 'บันทึกเป็น WORD',
  saveExcel: 'บันทึกเป็น EXCEL',
  email: 'อีเมล',
  fax: 'แฟกซ์',
  company: 'ชื่อบริษัท',
  emailAddress: 'ที่อยู่อีเมล',
  cc: 'สำเนา',
  title: 'หัวข้ออีเมล',
  content: 'เนื้อหาอีเมล',
  localAgent: 'ตัวแทนท้องถิ่น',
  destinationAgent: 'ตัวแทนท่าเรือต้นทาง/ปลายทาง',
  designationAgent: 'ตัวแทนสินค้าที่กำหนด',
  customer: 'ลูกค้า',
  bookingAgent: 'ตัวแทนจองพื้นที่',
  motorcade: 'กองยานพาหนะ',
  warehouse: 'คลังสินค้า',
  send: 'ส่ง',
  cancel: 'ยกเลิก',
  tel: 'โทรศัพท์',
  ok: 'ตกลง',
  faxCode: 'รหัสพื้นที่',
  faxNo: 'หมายเลขแฟกซ์',
  faxExt: 'หมายเลขต่อ',
  BlAddress: 'ที่อยู่สำหรับตรวจสอบ',
  ShippingCmp: 'บริษัทเรือ',
  NominatedAgent: 'ตัวแทนสินค้าที่กำหนด',
  PortAgency: 'ตัวแทนท่าเรือต้นทาง/ปลายทาง',
  InvokeLocalMailClient: 'เรียกใช้กล่องจดหมายท้องถิ่น'
}
